<ion-menu contentId="app" side="end" type="overlay" (keydown.esc)="handleEscapeKey($event)" (ionWillOpen)="menuWillOpen()">
  <ion-content>
    <ion-toolbar>
      @if (loggedIn$ | async) {
        <h2 #title class="font-large color-primary padding-left-l" tabindex="0">Welcome, {{ (user$ | async)?.firstName }}</h2>
        <div class="separator-line"></div>
      }
      <ion-buttons slot="primary">
        <ion-menu-button color="primary" icon-only>
          <ion-icon name="close"></ion-icon>
        </ion-menu-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-list>
      @if ((loggedIn$ | async) === false) {
        <ion-menu-toggle color="primary" fill="clear">
          <a (click)="login()" (keydown.enter)="login()" (keydown.space)="login(); $event.preventDefault()" tabindex="0"> Log in/ Registration </a>
        </ion-menu-toggle>
      } @else {
        <div class="margin-top-l">
          <ion-item lines="none">
            <ion-label>NCEA Permission</ion-label>
            <ion-toggle [checked]="hasNceaPermission$ | async" (click)="toggleNceaPermission()" color="success"></ion-toggle>
          </ion-item>
        </div>
      }
    </ion-list>
  </ion-content>
</ion-menu>
